import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-form-approval-success-modal',
  templateUrl: './form-approval-success-modal.component.html',
  styleUrls: ['./form-approval-success-modal.component.scss']
})
export class FormApprovalSuccessModalComponent {


  public data: any;  

  constructor(protected dialogRef: NbDialogRef<FormApprovalSuccessModalComponent>) {
    this.data = this.dialogRef;  
  }

  approve() {
    this.dialogRef.close(true); // Pass true to indicate approval
  }




}
